export default "__VITE_ASSET__04ec1008__"